import React, { useState } from "react";
import { roundness } from "../../../utils/styles";

const Filter = (props) => {
  const [hover, setHover] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [selected, setSeleted] = useState([]);

  const { listOfAllTags, setFilterName, isBreakpoint } = props;
  const [openFilter, setOpenFilter] = useState(isBreakpoint ? false : true);

  const all = 1000;
  const showHide = 2000;

  return (
    <>
      <div style={styles.openFilterButtonContainer}>
        <button
          style={styles.filterButton(hoverIndex === showHide, "#000000", false)}
          onMouseEnter={(e) => {
            setHover(true);
            setHoverIndex(showHide);
          }}
          onMouseLeave={(e) => {
            setHover(false);
            setHoverIndex(null);
          }}
          onClick={(e) => {
            setOpenFilter(!openFilter);
          }}
        >
          Show/Hide Filters
        </button>
      </div>
      {openFilter ? (
        <div style={styles.tagsContainer}>
          <button
            style={styles.filterButton(hoverIndex === all, "#000000", false)}
            onMouseEnter={(e) => {
              setHover(true);
              setHoverIndex(all);
            }}
            onMouseLeave={(e) => {
              setHover(false);
              setHoverIndex(null);
            }}
            onClick={(e) => {
              setSeleted([]);
              setFilterName([]);
            }}
          >
            Clear All
          </button>
          {listOfAllTags.map((tagObj, index) => {
            const { tag, color } = tagObj;
            return (
              <button
                key={index}
                style={styles.filterButton(
                  hover && hoverIndex === index,
                  color,
                  selected.indexOf(tag) > -1
                )}
                onMouseEnter={(e) => {
                  setHover(true);
                  setHoverIndex(index);
                }}
                onMouseLeave={(e) => {
                  setHover(false);
                  setHoverIndex(null);
                }}
                onClick={(e) => {
                  setFilterName((state) => {
                    if (state.indexOf(tag) > -1) {
                      const newState = state.filter((item) => item !== tag);
                      setSeleted(newState);
                      return newState;
                    } else {
                      const newState = [...state, tag];
                      setSeleted(newState);
                      return newState;
                    }
                  });
                }}
              >
                {tag}
              </button>
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export default Filter;

const styles = {
  tagsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    rowGap: 10,
    columnGap: 10,
  },
  openFilterButtonContainer: {
    paddingBottom: 20,
  },
  filterButton: (hover, color, selected) => {
    const common = {
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 16,
      paddingRight: 16,
      borderStyle: "solid",
      borderWidth: 2,
      fontSize: 12,
      color: "white",
      cursor: "pointer",
      transition: "ease-in-out 0.3s",
      borderRadius: roundness.button,
    };

    if (selected) {
      return {
        ...common,
        borderColor: color,
        background: color,
      };
    } else {
      return {
        ...common,
        borderColor: hover ? color : color + "80",
        background: hover ? color + "95" : "transparent",
      };
    }
  },
};
